import React from "react";
import "./Conntact.css";
import { MdOutlineEmail } from "react-icons/md";
import { GrInstagram } from "react-icons/gr";
import { BsWhatsapp } from "react-icons/bs";
import { useForm, ValidationError } from "@formspree/react";

const Conntact = () => {
  const [state, handleSubmit] = useForm("myyqlpqz");
  if (state.succeeded) {
    return (
      <>
        <section id="conntact">
          <h5>Get In Touch</h5>
          <h2>Contact Me</h2>
          <div className="container contact__container">
            <div className="contact__options">
              <article className="contact__option">
                <MdOutlineEmail className="contact__option-icon" />

                <h4>Email</h4>
                <h5>mahboobabubakar786@gmail.com</h5>
                <a
                  href="mailto:mahboobabubakar786@gmail.com"
                  target={"_blank"}
                  rel="noopener noreferrer"
                >
                  Send an email
                </a>
              </article>
              <article className="contact__option">
                <GrInstagram className="contact__option-icon" />
                <h4>Instagram</h4>
                <h5>Abubakar Chaudhary</h5>
                <a
                  href="https://instagram.com/ab_tech_solutions_?igshid=MzMyNGUyNmU2YQ=="
                  target={"_blank"}
                  rel="noopener noreferrer"
                >
                  Send a message
                </a>
              </article>
              <article className="contact__option">
                <BsWhatsapp className="contact__option-icon" />
                <h4>Whatsapp</h4>
                <h5>+92 331 4722 193</h5>
                <a
                  href="https://web.whatsapp.com/send?phone=+923314722193"
                  target={"_blank"}
                  rel="noopener noreferrer"
                >
                  Send a message
                </a>
              </article>
            </div>
            <p>
              Thanks for reaching out! I'll get back to you soon!{" "}
              <span>:)</span>
            </p>
          </div>
        </section>
      </>
    );
  }
  return (
    <section id="conntact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />

            <h4>Email</h4>
            <h5>mahboobabubakar786@gmail.com</h5>
            <a
              href="mailto:mahboobabubakar786@gmail.com"
              target={"_blank"}
              rel="noopener noreferrer"
            >
              Send an email
            </a>
          </article>
          <article className="contact__option">
            <GrInstagram className="contact__option-icon" />
            <h4>Instagram</h4>
            <h5>abubakarchaudhary</h5>
            <a
              href="https://instagram.com/ab_tech_solutions_?igshid=MzMyNGUyNmU2YQ=="
              target={"_blank"}
              rel="noopener noreferrer"
            >
              Send a message
            </a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>Whatsapp</h4>
            <h5>+92 331 4722 193</h5>
            <a
              href="https://web.whatsapp.com/send?phone=+923314722193"
              target={"_blank"}
              rel="noopener noreferrer"
            >
              Send a message
            </a>
          </article>
        </div>
        {/* END OF CONTACT OPTION */}
        <form onSubmit={handleSubmit}>
          <input
            id="name"
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <ValidationError prefix="Name" field="name" errors={state.errors} />
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Your Email"
            required
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
          <textarea
            id="message"
            name="message"
            rows="7"
            placeholder="Your Message"
          />
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
          <button type="submit" className="btn btn-primary">
            Send a Message
          </button>
        </form>
        <a href="#header" className="scroll__up">
          Scroll Up ^
        </a>
      </div>
    </section>
  );
};

export default Conntact;
